/**

 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#dosekiryukeikaikuiki
 * @type {Collapse}
 * 土砂災害警戒区域（急傾斜地の崩壊）
 */
module.exports = class Collapse {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '土砂災害警戒区域の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/sediment.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#dosekiryukeikaikuiki'
      }
    ];
  }
}
